import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import useUpdate from "hooks/useUpdate";

import { Dashboard, InputColorPicker } from "components";

const InputField = (props) => <Input {...props} />;
const InputColorPickerField = (props) => <InputColorPicker {...props} />;

const BasicData = ({
  shop_id,
  refetch,
  change,
  submitting,
  handleSubmit,
  pristine,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/shops/${shop_id}`,
    onSuccess: refetch,
  });

  const onSubmit = async (values) => update(values);

  return (
    <Dashboard
      header={{
        icon: "info",
        title: "Podstawowe dane",
      }}
      footer={
        <Button
          type="save"
          text="Zapisz"
          disabled={pristine || submitting || is_updating}
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="row m-b-10">
          <div className="box-6">
            <Field
              name="name"
              label="Nazwa"
              component={InputField}
              type="text"
            />
          </div>
          <div className="box-6">
            <Field
              name="identifier"
              label="Identyfikator"
              component={InputField}
              type="text"
            />
          </div>
        </div>
        <div className="row m-b-10">
          <div className="box-6">
            <Field
              name="label_text"
              label="Skrócona nazwa"
              component={InputField}
              type="text"
            />
          </div>
          <div className="box-6">
            <Field
              name="label_color"
              label="Kolor"
              handleChange={(color) => change("label_color", color)}
              component={InputColorPickerField}
            />
          </div>
        </div>
      </form>
    </Dashboard>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors["name"] = "Nazwa jest wymagana!";
  }

  if (!values.label_text) {
    errors["label_text"] = "Skrócona nazwa jest wymagana!";
  }

  if (!values.label_color) {
    errors["label_color"] = "Kolor jest wymagany!";
  }

  if (!values.identifier) {
    errors["identifier"] = "Identyfikator jest wymagany!";
  }

  return errors;
};

export default reduxForm({
  form: "edit-shop",
  enableReinitialize: true,
  validate,
})(BasicData);
